import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import { Cropper } from 'vue-advanced-cropper'
import Loading from './../../../../../../../Loading/Index'
import watch from './attrs/watch'

export default {
    name: 'Casting',
    computed,
    data,
    methods,
    watch,
    components: {
        Cropper,
        Loading
    }
}
